import { Routes, Route, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Contact from "./Contact";
import ContactEnquiries from "./ContactEnquiries";
import "./Dashboard.css";

const Dashboard = () => {

  const navigate = useNavigate();

  const handleLogout = () => {

    localStorage.removeItem("admin");

    navigate("/login");

  };

  return (
    <div className="dashboard">

      <Sidebar />

      <div className="dashboard-content">

        <div className="dashboard-header">

          <h2>Admin Dashboard</h2>

          <button
            className="logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>

        </div>

        <Routes>

          <Route
            path="/"
            element={<h3>Welcome Admin</h3>}
          />

          <Route
            path="contact"
            element={<Contact />}
          />

          <Route
            path="contactenquiry"
            element={<ContactEnquiries />}
          />
          
        </Routes>

      </div>

    </div>
  );
};

export default Dashboard;